import React, { useState } from 'react';
import Input from 'components/input';
import styles from '../../products.module.scss';
import cx from 'classname';
import plus from '../../../../assets/images/plus.png';
import { globalStyles } from 'styles';
import plusRed from '../../../../assets/svgs/plusRed.svg';
import moreRed from '../../../../assets/svgs/moreRed.svg';
import Dropdownbody, {
  stylesForDropDown,
} from 'components/Dropdown/dropdownbody';
import ToolTip from 'components/Tooltip';
import { PlusSquareIcon } from 'components/icons';
import MultiSelectModal from 'container/Products/CreateProductSteps/MultiSelectModal';

const PlanProduct = (props) => {
  const {
    state,
    setState,
    setNewState,
    onClick,
    removeClick,
    addCategory,
    deleteCategory,
    showMultiSelect,
    setShowMultiSelect,
  } = props;
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [current, setCurrent] = useState({});
  const [key, setKey] = useState(null);

  const openUp = (i) => {
    setId(i);
    setOpen((prevOpen) => !prevOpen);
  };

  const handleChange = () => {
    setNewState(props.getValues());
  };

  const multi = (i, value) => {
    let plans = [...state.plans];
    plans[i].allowMultiSelect = value;
    setState({ plans });
  };

  return (
    <div data-testid="plan product">
      {state?.plans &&
        state.plans.map((res, i) => {
          const fieldName = `plans[${i}]`;
          return (
            <div>
              <div
                className={cx(
                  globalStyles.flex,
                  globalStyles.justifyContentBetween,
                )}
              >
                <div className={cx(globalStyles.w100, globalStyles.mr24)}>
                  <Input
                    onChange={handleChange}
                    label={`Plan ${i + 1} title`}
                    type="text"
                    placeholder="Input title here"
                    autoFocus
                    defaultValue={res.name}
                    id={`${i}`}
                    ref={props.register({
                      required: 'Please enter title',
                    })}
                    error={
                      props.errors &&
                      props.errors['plans']?.[i]?.['name']?.message
                    }
                    name={`${fieldName}.name`}
                    data-testid="plan title"
                  />
                </div>
                <div className={cx(globalStyles.w100)}>
                  <Input
                    onChange={handleChange}
                    label={`Plan ${i + 1} amount`}
                    type="number"
                    placeholder="Input amount here"
                    autoFocus
                    defaultValue={res.value}
                    id={`${i}`}
                    ref={props.register({
                      required: 'Please enter an amount',
                      min: {
                        value: 100,
                        message: 'Amount cannot be less than 100',
                      },
                      max: {
                        value: 1000000,
                        message: 'Amount cannot be greaater than 1,000,000',
                      },
                    })}
                    error={
                      props.errors &&
                      props.errors['plans']?.[i]?.['value']?.message
                    }
                    name={`${fieldName}.value`}
                    data-testid="plan value"
                  />
                </div>
              </div>

              {res.categories &&
                res.categories.map((dat, idx) => {
                  const fieldNames = `plans[${i}].categories[${idx}]`;
                  return (
                    <div>
                      <div
                        className={cx(
                          globalStyles.flex,
                          globalStyles.justifyContentBetween,
                        )}
                      >
                        <div
                          className={cx(globalStyles.w100, globalStyles.mr24)}
                        >
                          <Input
                            label={`Category ${idx + 1} title`}
                            type="text"
                            placeholder="Input title here"
                            autoFocus
                            onChange={handleChange}
                            defaultValue={dat.name}
                            id={`${idx}`}
                            ref={props.register({
                              required: 'Please enter a category title',
                            })}
                            error={
                              props.errors &&
                              props.errors['plans']?.[i]?.['categories']?.[
                                idx
                              ]?.['name']?.message
                            }
                            name={`${fieldNames}.name`}
                          />
                        </div>
                        <div className={cx(globalStyles.w100)}>
                          <Input
                            label={`Category ${idx + 1} amount`}
                            type="number"
                            placeholder="Input amount here"
                            autoFocus
                            onChange={handleChange}
                            defaultValue={dat.value}
                            id={`${idx}`}
                            ref={props.register({
                              required: 'Please enter a category amount',
                              min: {
                                value: 100,
                                message: 'Amount cannot be less than 100',
                              },
                              max: {
                                value: 1000000,
                                message:
                                  'Amount cannot be greaater than 1,000,000',
                              },
                            })}
                            error={
                              props.errors &&
                              props.errors['plans']?.[i]?.['categories']?.[
                                idx
                              ]?.['value']?.message
                            }
                            name={`${fieldNames}.value`}
                          />
                        </div>
                      </div>
                      <div className={styles.deleteSec}>
                        <button onClick={() => deleteCategory(i, idx)}>
                          <div className={globalStyles.flex}>
                            <img src={plusRed} alt="plus" />
                            <p className={styles.typeTitle2}>Delete category</p>
                          </div>
                        </button>
                      </div>
                    </div>
                  );
                })}

              <div
                className={cx(
                  globalStyles.flex,
                  globalStyles.justifyContentBetween,
                )}
              >
                <button
                  className={styles.addCat}
                  onClick={() => {
                    addCategory(i);
                    setCurrent(res);
                    setKey(i);
                  }}
                >
                  <div className={globalStyles.flex}>
                    <PlusSquareIcon />
                    <p className={styles.typeTitle}>Add category</p>
                    {i === 0 && (
                      <div className={styles.typeIcon}>
                        <ToolTip
                          id="create-product-title"
                          content="Add category toolip content"
                        />
                      </div>
                    )}
                  </div>
                </button>
                <div>
                  {i === 0 || i === 1 ? null : (
                    <div>
                      <div className={styles.actionTop}>
                        <div className={styles.actionHead}>
                          <img src={moreRed} alt="red" />
                          <span
                            className={styles.typeTitle2}
                            onClick={() => openUp(i)}
                          >
                            Actions
                          </span>
                        </div>
                      </div>
                      {id === i && open ? (
                        <Dropdownbody>
                          <button
                            className={cx(
                              stylesForDropDown.dropdownitem,
                              styles.dropWidth,
                            )}
                            onClick={() => {
                              removeClick(i);
                              setOpen((prevOpen) => !prevOpen);
                            }}
                          >
                            <p className={stylesForDropDown.dropdownitemtext}>
                              Delete plan
                            </p>
                          </button>
                        </Dropdownbody>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
              <hr className={styles.planHr} />
              <MultiSelectModal
                onSelect={(value) => multi(key, value)}
                onClose={() => setShowMultiSelect(false)}
                register={props.register}
                name={`${fieldName}.allowMultiSelect`}
                showMultiSelect={showMultiSelect}
                setShowMultiSelect={setShowMultiSelect}
                item={current}
                key={key}
              />
            </div>
          );
        })}

      <div
        className={cx(globalStyles.flex, globalStyles.justifyContentBetween)}
      >
        <div></div>
        <button className={styles.addPlanButton} onClick={onClick}>
          <img src={plus} alt="plus" />
          Add Plan
        </button>
      </div>
    </div>
  );
};

export default PlanProduct;
